import { useCallback, useEffect, useState, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import styles from './LandAcknowledgement.module.css';


const landAcknowledgementPath = <svg viewBox="0 0 30.9 30"  ><path d="M20.4,8.9c2.5,0.3,0.6,3.1,0.1,4.4c2.3,0,2.3-6.7,4.9-3.9c-0.4,1.2,1.6,2.2,0.5,3c-1.4,0.9-2.6,3.2-5.7,2.5
	c-0.7,0.5-1.3,1.9-1,2.2c1,0,1.5-0.6,2.1-1.2c1.6-0.2,1.6,1.8,2.6,2.7c0.7-0.4,1-1.2,0.9-2c-0.2-1.6,1.7-0.2,1.3-1.7
	c-0.1-1,0-1.1,1-1c1-3.2,2.8-1.1,3.8,0.8c-2.5,2-0.5,2.8-3.1,4.6c3-1.3,1,3.1,0.5,4.1c-3.1,1.6-7.2,8-11.3,6.2
	c-0.2-2.1-3.1-2.7-4.6-3.2c0.4,1.6,0.8,2.2,1.7,3.3c-3.9,0.1-11.3-3.7-7.2-5.1c-1.6-2.7-7.3-3.8-5.2-7.8c0.3-1.2-0.9-2-1.4-2.9
	c-0.7-1.1-0.1-1.4,1-1.6C0.8,9.4,4.4,6.9,4.7,11c0.1,1.3-0.1,5.9,2,4.9c-2.4-3.2,1-5.7,1.7-1.2c0.9-2.9-3.3-5-2.8-8.1
	C5.4,5.4,7.8,4.7,7.7,6.3c0,2.2,2.7-0.8,2.2,2.2c1.6-1.2,2.6-0.4,2.6,1.5c0.7-0.5,0.3-1.7,0.9-2c0-1.4-1.6-5.6,0.8-4.2
	c-0.9-2.4,0.2-4.1,2.7-3.8c1.5,1.5-1,3.6,0.8,5c-2.1,0.5-1.5,3.2-1.8,4.9C16.3,8.8,17,8.7,18.1,9c1.1-0.7-0.3-2.1-0.6-3.4
	c1-0.6,0.9-1.7,1-2.7c1.1-2.8,2.1,0.8,3.2,1.1C24.3,4.4,20.7,7.5,20.4,8.9z M21.6,26.4c1.5-1.3,4.2-3.9,3.6-6.3
	C23,21.6,22.3,23.9,21.6,26.4z M15.7,24c2.8-5.2-0.7-8.8-2.4-9.8C12.9,17.2,16.3,19.6,15.7,24z M18.2,15c1.4-1.1,0.9-3.6,1-5.1
	c-1.4,1.1-1.8,2.9-1,4.4L18.2,15z M6.2,17.7c0.3,0.9,0.3,2,0,2.9C8.1,20,7.9,18.5,6.2,17.7z M11.1,18c-0.1,1,0.4,4.6,1.9,5
	C13.8,21.2,12,18.6,11.1,18z M12.8,13c-0.8-2-1.6-1.3-1.2,0.6C11.8,13.2,12.3,12.9,12.8,13z M15.5,11.8c-0.4,0.9,0.3,2.8,1.2,3.2
	c0.4-1.1-0.3-1.5-0.8-2.3L15.5,11.8z M21.1,20.1c-1.2,0-1.9,1.6-1.6,3.1c0,0.3,0.2,0.5,0.4,0.6C20,22.3,20.4,21,21.1,20.1z"/></svg>


const showInterval = 4800;  //4800 for quick tings
const hideInterval = 2400; // 2400 for hidin

function LandAcknowledgement() {
    const [landAcknowledged, setLandAcknowledged] = useState(false);

    const landAcknowledgementText =
        "We live and work on stolen land. The struggle for the rights of Indigenous peoples in Australia is ongoing, and recognising their traditional connection to Country is a small step to restoring dignity to the lives of all Australians.";

    const {
        ref: landAcknowledgementRef,
        inView: landAcknowledgementVisible }
        = useInView({
            threshold: 0.7,
            rootMargin: "10% 0px -20% 0px",
            onChange: (inView, entry) => {
                if (inView) {
                    setLandAcknowledged(true);
                } else {
                    if (entry.boundingClientRect.top > 0) {
                        if (landAcknowledged) { setLandAcknowledged(true) } else { setLandAcknowledged(false) };
                    } else {
                        if (!landAcknowledged) { setLandAcknowledged(false) } else { setLandAcknowledged(false) };
                    }
                }
            }
        });



    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {

        if (fadeIn) {
            setTimeout(() => {
                setFadeIn(false);
            }, showInterval);
        } else {
            setTimeout(() => {
                setFadeIn(true);
                //nextItem();
            }, hideInterval);
        }

    });


    return (

        <div className={styles.landAcknowledgementContainer}
            ref={landAcknowledgementRef}
        >
            {/*
            

            */}
            <p className={landAcknowledged ?
                styles.acknowledgementTextFadeIn : styles.acknowledgementTextFadeOut}>
                {landAcknowledgementText}
            </p>
            <svg className={landAcknowledged ? styles.acknowledgementMotifFadeIn : styles.acknowledgementMotifFadeOut}
                >{landAcknowledgementPath}</svg>

        </div>

    );
}

export default LandAcknowledgement;
